module.exports = __webpack_public_path__ + "img/Hesston 1.2 x 1.2.17da0eb9.jpg";